import { render, staticRenderFns } from "./newnessEdit.vue?vue&type=template&id=50afe71e&scoped=true&"
import script from "./newnessEdit.vue?vue&type=script&lang=js&"
export * from "./newnessEdit.vue?vue&type=script&lang=js&"
import style0 from "./newnessEdit.vue?vue&type=style&index=0&id=50afe71e&scoped=true&lang=less&"
import style1 from "./newnessEdit.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50afe71e",
  null
  
)

export default component.exports